var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconionicLogoWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.423,
    height: 17.423,
    viewBox: "0 0 17.423 17.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#26093a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.12,2.25a8.521,8.521,0,0,0-8.553,8.487A8.4,8.4,0,0,0,3.794,15.12L2.25,19.673l4.736-1.5a8.568,8.568,0,0,0,12.688-7.432A8.52,8.52,0,0,0,11.12,2.25Zm4.253,11.711a2.209,2.209,0,0,1-1.513.975c-.4.021-.413.311-2.6-.639a8.924,8.924,0,0,1-3.606-3.41,4.2,4.2,0,0,1-.807-2.273A2.424,2.424,0,0,1,7.68,6.835a.838.838,0,0,1,.592-.249c.172,0,.284-.005.411,0S9,6.559,9.168,7s.562,1.523.612,1.633a.4.4,0,0,1,0,.38,1.485,1.485,0,0,1-.232.353c-.114.122-.24.274-.342.367s-.232.217-.113.438a6.545,6.545,0,0,0,1.158,1.545,5.968,5.968,0,0,0,1.715,1.14c.214.117.342.1.475-.036s.569-.612.723-.823.3-.17.5-.091,1.251.644,1.465.76.358.176.409.268A1.8,1.8,0,0,1,15.373,13.961Z",
    transform: "translate(-2.25 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicLogoWhatsapp);
export default __webpack_public_path__ + "static/media/Icon ionic-logo-whatsapp.18d380b638d77b088deb392c01d16ab6.svg";
export { ForwardRef as ReactComponent };